import * as React from 'react';
import Row from '../Components/Row';
import Validator from '../Helpers/validator';
import Radio from '../Components/Radio';
import Button from '../Components/Button';
import Member from '../Models/Member';
import TextInput from '../Components/TextInput';
import CountrySelect from '../Components/CountrySelect';

function isEquivalent(a: Object, b: Object) {
  // Create arrays of property names
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length !== bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];

    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false;
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true;
}

interface Props {
  member: Member;
  giftAidOptions: GiftAidOptions;
  giftAidDisclaimer: string;
  useMemberAddress: boolean;
  // Adding CSS class for changing the styling properties
  buttonClass?: string;
  backGroundColorClass?: string;
  updateGiftAid(mutate: (ga: GiftAidOptions) => void): void;
  next?(): void;
}

class GiftAidModule extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    props.updateGiftAid(ga => {
      ga.addressLine1 = props.member.address.line1;
      ga.addressLine2 = props.member.address.line2;
      ga.addressLine3 = props.member.address.line3;
      ga.county = props.member.address.county;
      ga.country = props.member.address.country;
      ga.town = props.member.address.town;
      ga.postcode = props.member.address.postcode;
    });
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    const props = this.props;

    if (isEquivalent(props.member.address, prevProps.member.address)) {
      return;
    }

    props.updateGiftAid(ga => {
      if (prevProps.member.address.line1 === ga.addressLine1) { ga.addressLine1 = props.member.address.line1; }
      if (prevProps.member.address.line2 === ga.addressLine2) { ga.addressLine2 = props.member.address.line2; }
      if (prevProps.member.address.line3 === ga.addressLine3) { ga.addressLine3 = props.member.address.line3; }
      if (prevProps.member.address.county === ga.county) { ga.county = props.member.address.county; }
      if (prevProps.member.address.country === ga.country) { ga.country = props.member.address.country; }
      if (prevProps.member.address.town === ga.town) { ga.town = props.member.address.town; }
      if (prevProps.member.address.postcode === ga.postcode) { ga.postcode = props.member.address.postcode; }
    });
  }

  handleGiftAidToggle = (isGiftAidChecked: boolean) => {
    this.props.updateGiftAid(ga => (ga.isSelected = isGiftAidChecked));
  };

  renderGiftaidForm() {

    const gaBuildOptions = {

      postcode: {
        label: 'Postcode *',
        validator: Validator.isPostcode,
        dataInvalidMessage: 'A valid postcode is required.',
        forceHighlightErrors: true
      }
    };

    return (
      <Row className="gift-aid-address">
        <div id="gift-aid-address-header">
          <b>Your UK Address</b>
          <br />
        </div>
        <div id="gift-aid-address-header">
          <span>
            Your address is needed to identify you as a current UK taxpayer.
          </span>
        </div>

        <TextInput
          key={'addressLine1'}
          id={'addressLine1'}
          value={this.props.giftAidOptions.addressLine1}
          label={'Address Line 1 *'}
          onChange={line2 => this.props.updateGiftAid(gao => gao.addressLine1 = line2)}

          validator={Validator.isNotEmpty}
          dataInvalidMessage={'Address Line 1 is required.'}
          forceHighlightErrors={true}
        />

        <TextInput
          key={'addressLine2'}
          id={'addressLine2'}
          value={this.props.giftAidOptions.addressLine2}
          label={'Address Line 2'}
          onChange={line2 => this.props.updateGiftAid(gao => gao.addressLine2 = line2)}
        />

        <TextInput
          key={'addressLine3'}
          id={'addressLine3'}
          value={this.props.giftAidOptions.addressLine3}
          label={'Address Line 3'}
          onChange={line3 => this.props.updateGiftAid(gao => gao.addressLine3 = line3)}
        />

        <TextInput
          key={'town'}
          id={'town'}
          value={this.props.giftAidOptions.town}
          label={'Town'}
          onChange={town => this.props.updateGiftAid(gao => gao.town = town)}
        />

        <TextInput
          key={'county'}
          id={'county'}
          value={this.props.giftAidOptions.county}
          label={'County'}
          onChange={county => this.props.updateGiftAid(gao => gao.county = county)}
        />

        <CountrySelect
          key={'country'}
          iso2Code={this.props.giftAidOptions.country}
          onChange={v => this.props.updateGiftAid(gao => {
            gao.country = v.countryName;
            gao.countryIso = v.iso2Code;
          })}

        />

      </Row>
    );
  }

  render() {
    let giftAidYes = this.props.giftAidOptions.isSelected === true;
    let giftAidNo = this.props.giftAidOptions.isSelected === false;

    return (
      <div id="membership-signup-giftaid">
        <div className={this.props.backGroundColorClass}>
          <Row>
            <div className="col s6">
              <span id="giftaid-description">
                Gift aid your donation and the Government will give us 25% on top
                of your donation. It doesn't cost you a penny and helps to keep us
                going.
            </span>
              <br />
              <span>Would you like to gift aid?</span>
              <br />
              <Radio
                label="Yes"
                id="gift-aid-yes"
                group="gift-aid"
                onChange={this.handleGiftAidToggle}
                defaultChecked={giftAidYes}
              />
              <Radio
                label="No"
                id="gift-aid-no"
                group="gift-aid"
                onChange={c => this.handleGiftAidToggle(!c)}
                defaultChecked={giftAidNo}
              />
            </div>
            <div className="col s6 logo">
              <img
                src={require('../images/giftaidlogoblack.png')}
                className="giftaidlogo"
                style={{ display: 'inline' }}
              />
            </div>
          </Row>
          <br />
          <span id="giftaid-disclaimer">
            {this.props.giftAidDisclaimer}
          </span>
        </div>
        <div className="member-details">
          {!this.props.useMemberAddress && this.renderGiftaidForm()}
          <br />
          {this.props.next && <Button className={this.props.buttonClass} onClick={this.props.next}>Proceed</Button>}
          <br />
        </div>
      </div>
    );
  }
}

export default GiftAidModule;



// WEBPACK FOOTER //
// ./src/Modules/GiftAidModule.tsx